import parseLocation from './parseLocation';

const DATA_LAYER = 'dataLayer';
const GTM_ID = 'GTM-P3TR5CG';

/**
 * Push google tag manager event
 * @param type
 * @param payload
 */

export function PushEvent(type, payload) {
  const locationParams = parseLocation(window.location.search) || {};
  const widgetVersion = window.__INITIAL_STATE__.xl.version;

  const dataLayer = window[DATA_LAYER] || [];
  const data = {
    event: type,
    widgetVersion,
    projectId: locationParams.projectId,
    ...payload
  };

  setTimeout(() => {
    dataLayer.push(data);
  }, 500);

  return data;
}

/**
 * Initialization google tag manager
 */

export function initialization() {
  const head = window.document.getElementsByTagName('script')[0];
  const script = window.document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}&l=${DATA_LAYER}`;
  script.onload = () => {
    const dataLayer = window[DATA_LAYER] || [];
    dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});

    PushEvent('Initialization');
  };

  head.parentNode.insertBefore(script, head);
}



// WEBPACK FOOTER //
// ./utils/googleTagManager.js